import GradientBlock from 'components/GradientBlock'
import MainTabs from 'components/main-components/MainTabs'
import PageBlockLogin from 'components/page-components/PageBlockLogin'
import { ProfileTabs } from 'consts/tabs'
import useProfile from 'hooks/useProfile'
import Cookies from 'js-cookie'
import { Outlet } from 'react-router-dom'

const ProfileRoute = () => {
  const { isLogged } = useProfile();
  const token = Cookies.get('token');

  return (
    <>
      <GradientBlock additionalClassName='gradient-block--purple'>
        <MainTabs tabs={ProfileTabs} />
      </GradientBlock>
      {!token && !isLogged ? <PageBlockLogin /> : <Outlet />}
    </>
  )
}

export default ProfileRoute
